// extracted by mini-css-extract-plugin
export var button = "styles-module--button--uUGPZ";
export var buttonShadow = "styles-module--button-shadow--g-zjh";
export var buttonWrapper = "styles-module--button-wrapper--CAh1G";
export var textDecoration = "styles-module--text-decoration--tc5N5";
export var textQuestionContainer = "styles-module--text-question-container--4DlI9";